export async function generatePortfolioSummary(result) {
  if (!result || !result.ok) {
    throw new Error("No valid portfolio result available.");
  }

  const response = await fetch("http://localhost:3001/api/portfolio-summary", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ result }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data?.error || "Failed to generate portfolio summary.");
  }

  if (!data?.summary || typeof data.summary !== "string") {
    throw new Error("Model returned no summary.");
  }

  return data.summary;
}